import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"
import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryFindPrevNextOrderForAdm = {
  async findPrevNextOrderForAdm(_parent, args, context, _info) {
    const { admNumber, currentOrderNumber, orderType, cdn, lang } = args
    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ORDERS,
      operation: Operations.READ,
    })

    const graphiQLQueryObject = [
      {
        method: "findPrevNextOrderForAdm",
        variables: { admNumber, currentOrderNumber, orderType },
        fields: ["previousOrderNumber", "nextOrderNumber"],
      },
    ]

    const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
    const customerOrderResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data?.findPrevNextOrderForAdm

    if (!customerOrderResponse) throw new Error("Customer prev and next order not found")

    return {
      previousOrderNumber: customerOrderResponse.previousOrderNumber,
      nextOrderNumber: customerOrderResponse.nextOrderNumber,
    }
  },
}
